import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class LabTest extends BaseDataModel {
	name: string = "";
	labName: string = "";
}
